import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { rxResource } from "@angular/core/rxjs-interop";
import { ScheduleLogService } from "@malirang/api-client";
import { injectQueryParams } from "ngxtension/inject-query-params";
import { DocumentBoxAccordian } from "../document-box/document-box-accordian/document-box-accordian";
import { ScheduleLogItemComponent } from "./schedule-log-item/schedule-log-item.component";

@Component({
    selector: "app-schedule-log",
    templateUrl: "./schedule-log.component.html",
    styleUrls: ["./schedule-log.component.css"],
    imports: [CommonModule, ScheduleLogItemComponent, DocumentBoxAccordian],
})
export class ScheduleLogComponent {
    readonly ticketId = injectQueryParams("ticketId");
    readonly scheduleLogService = inject(ScheduleLogService);

    $items = rxResource({
        stream: () =>
            this.scheduleLogService.scheduleLogControllerFindByTicketIdWithMonth(
                {
                    ticketId: this.ticketId() || "",
                },
            ),
    });
    items = this.$items.value;
}
